import { useMemo } from 'react';
import type { DrillProps } from './meta';
import { NumberDrill } from './NumberDrill';
import { makeOpRound } from './op';

export function OpDrill({ level, seed, onDone }: DrillProps) {
  const questions = useMemo(() => makeOpRound(level, seed), [level, seed]);
  return (
    <NumberDrill
      questions={questions} seed={seed} onDone={onDone} className="seq-drill op-drill"
      info={(q) => ({ rule: q.rule, examples: q.examples, query: q.query, answer: q.answer })}
      render={(q, revealed) => (
        <div className="op-board" aria-label="기호 연산 예시">
          {q.examples.map((e) => (
            <div key={`${e.a}-${e.b}`} className="op-line">
              {e.a} <b className="op-sym">{q.symbol}</b> {e.b} <span className="op-eq">=</span> {e.result}
            </div>
          ))}
          <div className="op-line ask">
            {q.query.a} <b className="op-sym">{q.symbol}</b> {q.query.b} <span className="op-eq">=</span> <span className="seq-term blank">{revealed ? q.answer : '?'}</span>
          </div>
        </div>
      )}
    />
  );
}
